import { Button, type ButtonProps } from "react-bootstrap";
import { MdContentCopy } from "react-icons/md";

const CopyButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="secondary" {...(props as ButtonProps)}>
    <MdContentCopy /> {children}
  </Button>
);

export default CopyButton;
